import React from 'react'

import Button from '../form/Button'
import BookmarkIcon from '../../../assets/icons/bookmark.svg?react'

type Props = { bookmarked?: boolean, onClick: () => void, children?: string }
const BookmarkButton: React.FC<Props> = ({ bookmarked, onClick, children }) => {
  const classes = `text-deep-green ${bookmarked ? 'fill-deep-green' : 'fill-white'}`
  const icon = <BookmarkIcon />
  return <Button className={`focus:outline-none px-0 sm:px-0 ${classes}`} icon={icon} variant='flat' size='md' onClick={onClick}>{children}</Button>
}

export default BookmarkButton
